import { ReactElement } from 'react';
import { OrderViewer } from '@mapado/seating';
import EventDatePagesHeader from '../components/EventDatePagesHeader';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoOrderViewer(): ReactElement {
  const cartId = useQueryNumberParam('cartId', 1125668);
  const eventDateId = useQueryNumberParam('eventDateId', 133018);

  return (
    <>
      <EventDatePagesHeader title="Visualisation" eventDateId={eventDateId} />

      <OrderViewer cartId={cartId} eventDateId={eventDateId} />
    </>
  );
}
